import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography, Paper } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import { styled } from '@mui/material/styles';
// LAP-733 (GE022) — translate the home view header.
import { useTranslation } from 'react-i18next';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  borderRadius: '12px',
  padding: '4px',
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: '8px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    '&:not(.Mui-selected)': {
      color: 'rgba(255, 255, 255, 0.7)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
  },
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  padding: '8px 20px',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  transition: 'all 0.3s ease',
}));

const HomeToggleHeader = ({ view, onViewChange }) => {
  const { t } = useTranslation('layout');
  const handleChange = (event, newView) => {
    if (newView !== null) {
      onViewChange(newView);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        background: 'linear-gradient(135deg, #001B42 0%, #003366 100%)',
        borderRadius: 0,
        py: 2,
        px: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        // position: 'sticky',
        // top: 64,
        zIndex: 1000,
        backdropFilter: 'blur(10px)',
      }}
    >
      <Box>
        <Typography 
          variant="h5" 
          sx={{ 
            color: '#fff', 
            fontWeight: 600,
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            textAlign: 'left',
          }}
        >
          {view === 'classic' ? t('home.title') : t('home.smartFeed')}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            display: 'block',
            mt: 0.5,
          }}
        >
          {view === 'classic'
            ? t('home.subtitle')
            : t('home.smartFeedSubtitle')}
        </Typography>
      </Box>

      <StyledToggleButtonGroup
        value={view}
        exclusive
        onChange={handleChange}
        aria-label="view toggle"
      >
        <StyledToggleButton value="classic" aria-label="classic view">
          <ViewModuleIcon fontSize="small" />
          {t('home.classic')}
        </StyledToggleButton>
        <StyledToggleButton value="smartfeed" aria-label="smart feed view">
          <DynamicFeedIcon fontSize="small" />
          {t('home.smartFeed')}
        </StyledToggleButton>
      </StyledToggleButtonGroup>
    </Paper>
  );
};

export default HomeToggleHeader;
